import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigurationService } from "../../../erp/services/base/appConfiguration.service";
import { Observable, catchError, map, throwError } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class QuizEstiloDeVidaService {
  constructor(
    private httpClient: HttpClient,
    private appConfigurationService: AppConfigurationService
  ) { }

  iniciarQuiz(dadosUsuario: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/LifestyleQuiz/StartLifestyleQuiz`, dadosUsuario)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err));
        })
      );
  }

  responderQuiz(resposta: any): Observable<any> {
    return this.httpClient
      .post<any>(
        `${this.appConfigurationService.apiBaseUrl}/LifestyleQuiz/AnswerQuestion`, resposta)
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err))
        })
      )
  }

  finalizarQuiz(idUsuario: string): Observable<any> {
    return this.httpClient
      .post<any>(`${this.appConfigurationService.apiBaseUrl}/LifestyleQuiz/FinishQuiz?lifestyleQuizPersonalDataId=${idUsuario}`, '')
      .pipe(
        map((response) => {
          return response;
        }),
        catchError((err) => {
          return throwError(() => new Error(err))
        })
      )
  }

}
